import axios from "axios"
import cookieService from "@/services/Cookie.service"

const URL = process.env.VUE_APP_API_URL
export const URLCOOKIE = process.env.VUE_APP_API_URL_COOKIE ?? ""

export const axiosInstance = (isBlob = false) => {
	const headers = {
		"Cache-Control":
			process.env.VUE_APP_CONNECTION_CACHE_CONTROL ?? "no-cache",
		Authorization: `Bearer ${cookieService.getCookie("token") ?? ""}`,
		Pragma: process.env.VUE_APP_CONNECTION_PRAMA ?? "no-cache",
		Expires: process.env.VUE_APP_CONNECTION_EXPIRES ?? "0"
	}

	return axios.create({
		baseURL: URL,
		headers: headers,
		responseType: isBlob ? "blob" : null,
		validateStatus: (status) => {
			return status < 400
		}
	})
}
